export const API_BASE_URL = '/api/v1';
export const NR_OF_ITEMS_PER_PAGE = 10;
// The value is in milliseconds (30s)
export const WS_TIMEOUT = 30000;
// The value is in milliseconds (10s)
export const WS_FALLBACK_INTERVAL = 10000;
export const WS_FALLBACK_NO_OF_RETRIES = 5;
export const WS_REGISTER_DELAY = 500;

export const WS_EVENT = {
	EVENT_UPDATE:     'EventUpdated',
	STREAM_UPDATE:    'StreamUpdated',
	EVENT_TAG_CREATE: 'EventTagCreated',
	EVENT_TAG_UPDATE: 'EventTagUpdated',
	EVENT_TAG_DELETE: 'EventTagDeleted',
	SCORE_UPDATED:    'ScoreUpdated',
};

export const EVENT_TAG_CREATE_THROTTLE_INTERVAL = 1000;

export const SORT_KEYS = {
	NEWEST_FIRST: 'newest_first',
	OLDEST_FIRST: 'oldest_first',
	VIEWS:        'views',
};
